import {createBrowserHistory, History} from "history";

export const apHistory = createBrowserHistory();
